import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { assertDefined } from "app/pages/sales-intelligence/utils/errors/assertions";
import { errorOperationMap } from "app/pages/sales-intelligence/utils/errors/context";

import { buildCompaniesSearchCountDto } from "../../utils/buildCompaniesSearchCountDto";
import { leadsSearchQueryKeys } from "../key-factory/factory";

type Params = {
    panelValue: Partial<LeadsSearchAllFiltersTypes>;
    isEnabled: boolean;
};

export const useCompaniesSearchCountQuery = ({ panelValue, isEnabled }: Params) => {
    const requestDto = useMemo(() => buildCompaniesSearchCountDto(panelValue), [panelValue]);

    const { data, isFetching, isError } = useQuery({
        enabled: isEnabled,
        queryKey: leadsSearchQueryKeys.companiesSearchCount(requestDto),
        queryFn: async ({ signal }) => {
            const response = await salesApiService.advancedSearchPage.companies.fetchSearchResults(requestDto, {
                cancellation: signal,
            });

            assertDefined(response, {
                name: "fetchCompaniesSearchCountResponse",
                operation: errorOperationMap.emptySearchResults,
            });

            return response.totalCount;
        },
    });

    return {
        totalCount: data,
        isLoading: isFetching,
        isError,
    };
};
